import React from "react";

export const EmailInstructions = ({ email }) => {
  return (
    <section className="htp-email-instructions">
      <p className="mb-2">
        Alternatively, you can start your print order by email:
      </p>

      <ol className="ps-4">
        <li>
          Email your documents to <a href={`mailto:${email}`}>{email}</a>.
        </li>
        <li>We'll email you back with a link to confirm payment.</li>
        <li>
          You'll receive the unique secure release code used to print your
          documents.
        </li>
      </ol>
    </section>
  );
};
